<template>
    <div class="page-container">
        <div class="side-nav" :class="{'disableSideNav' : isDisabled}">
            <div class="side-nav__search-area">
                <div class="side-nav__input-group">
                    <div class="side-nav-input">
                        <img src="/images/icons/search.svg" alt="">
                        <input type="text" v-model="tenantNameSearch" placeholder="Tenant name" />
                    </div>
                    <a class="add-btn" @click="createTenant">
                        <img src="/images/icons/add.svg" alt="Add">
                    </a>
                </div>
                <div class="side-nav__input-group">
                    <a-select
                        v-model:value="sectionSelect"
                        show-search
                        placeholder="Section: All"
                        style="width: 100%"
                        option-filter-prop="children"
                        :options="listSection"
                        :filter-option="filterOption"
                        @change="handleChangeSection"
                    >
                        <a-select-option v-for="item in listSection" :key="item.value"
                                         :value="item.value"
                                         name="section"
                        >
                            {{ item.label }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="side-nav__input-group">
                    <div class="col">
                        <a-select
                            v-model:value="categorySelect"
                            show-search
                            placeholder="Category: All"
                            style="width: 100%"
                            option-filter-prop="children"
                            :options="listCategory"
                            :filter-option="filterOptionCategory"
                            @change="handleChangeCategory"
                        >
                            <a-select-option v-for="item in listCategory" :key="item.value"
                                             :value="item.value"
                                             name="category"
                            >
                                {{ item.label }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="col">
                        <a-select
                            v-model:value="lsPointSelect"
                            show-search
                            placeholder="LS.POINT: All"
                            style="width: 100%"
                            option-filter-prop="children"
                            :options="SELECT_LS_POINT"
                            :filter-option="filterOptionLSPOINT"
                            @change="handleChangeLsPoint"
                        >
                            <a-select-option v-for="item in SELECT_LS_POINT" :key="item.value"
                                             :value="item.value"
                                             name="lsPoint"
                            >
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
            </div>
            <div class="side-nav__item-list">
                <SideNavTenantItem
                    v-for="item in items"
                    :key="item.id"
                    :attribute="item.ls_point"
                    :category="item.section_name"
                    :selected="selected === item.id"
                    :sub-category="item.category_name"
                    :title="item.name"
                    @click="selectTenant(item.id, item)"
                >
                </SideNavTenantItem>
            </div>
        </div>
        <div v-if="!isCreateTenant && !isSelected" class="tenant-main-page">
            <div class="main-content">
                <div class="text-center">
                    <img src="/images/icons/no_tenant_select.svg">
                </div>
            </div>
        </div>

        <NewTenantContent v-if="isCreateTenant">
        </NewTenantContent>

        <TenantMainContent
            v-if="isSelected"
            :key="tenant.id"
            :selected="isSelected"
            :listSection="filterListSection"
            :listCategory="filterListCategory"
            v-bind:tenant="tenant"
        >
        </TenantMainContent>
    </div>
</template>

<script>
import Layout from "../Layout.vue";
import SideNavInput from "../reusable/SideNavInput.vue";
import SideNavSelect from "../reusable/SideNavSelect.vue";
import TenantSearchArea from "./TenantSearchArea.vue";
import SideNav from "../SideNav.vue";
import SideNavTenantItem from "../reusable/SideNavTenantItem.vue";
import TenantMainContent from "./TenantMainPage.vue";
import CustomSelect from "../reusable/CustomSelect.vue";
import NewTenantContent from "./NewTenant.vue";
import {LS_POINT, NOT_LS_POINT, SELECT_LS_POINT} from "../../const";
const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
const filterOptionCategory = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
const filterOptionLSPOINT = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
export default {
    name: "tenants",
    components: {
        CustomSelect,
        TenantMainContent,
        SideNavTenantItem, SideNav, TenantSearchArea, SideNavSelect, SideNavInput, Layout,
        NewTenantContent
    },
    data() {
        return {
            user: this.$store.state.auth.user,
            paramSearch: {},
            loading: false,
            watcher: false,
            tenantNameSearch: '',
            sectionSelect: undefined,
            categorySelect: undefined,
            lsPointSelect: undefined,
            items: [],
            selected: '',
            tenant: '',
            isSelected: false,
            SELECT_LS_POINT,
            LS_POINT,
            NOT_LS_POINT,
            newTenant: {
                id: 0,
                name: '...',
                section_name: '...',
                category_name: '...',
                ls_point: NOT_LS_POINT
            },
            listSection: [],
            listCategory: [],
            listLsPoint: [],
            filterListSection: '',
            filterListCategory: '',
            filterListLsPoint: '',
            isCreateTenant: false,
            filterOption,
            filterOptionCategory,
            filterOptionLSPOINT,
            isDisabled: false
        }
    },
    created() {
        this.fetch(this.paramSearch)
        this.getListSection();
        this.getListCategory();
        this.filterListLsPoint = SELECT_LS_POINT.slice(1);
    },
    mounted() {
        this.emitter.on("deleteTenant", tenantId => {
            this.items = this.items.filter((item) => item.id != tenantId)
            this.isSelected = false
        });

        this.emitter.on("removeClass", isRemoveClass => {
            if (isRemoveClass) {
                this.isDisabled = false
                this.isSelected = false
                this.isCreateTenant = false
                this.selected = ''
                this.fetch(this.paramSearch)
            }
        });

        this.emitter.on("cancel", isCancel => {
            if (isCancel) {
                this.isDisabled = false
                this.isSelected = false
                this.isCreateTenant = false
                this.selected = ''
                this.fetch(this.paramSearch)
            }
        });

        this.emitter.on("updateTenant", isUpdateTenant => {
            if (isUpdateTenant) {
                this.fetch(this.paramSearch)
            }
        });

        this.emitter.on("modeUpdate", isModeUpdate => {
            this.isDisabled = false;

            if (isModeUpdate) {
                this.isDisabled = true
            }
        });
    },
    methods: {
        fetch(params = {}) {
            this.loading = true;
            axios.get('/admin/tenants/getListTenant', {params: params}).then(response => {
                this.items = response.data
                this.loading = false;
                this.watcher = true;
            });
        },
        createTenant() {
            this.isSelected = false;
            this.isCreateTenant = true
            this.isDisabled = true
            this.selected = 0
            this.items.unshift(this.newTenant)
        },
        handleChangeSection(value) {
            this.isCreateTenant = false;
            this.isSelected = false;
            this.paramSearch.sectionSelect = value
            this.fetch(this.paramSearch)
        },
        handleChangeCategory(value) {
            this.isCreateTenant = false;
            this.isSelected = false;
            this.paramSearch.categorySelect = value
            this.fetch(this.paramSearch)
        },
        handleChangeLsPoint(value) {
            this.isCreateTenant = false;
            this.isSelected = false;
            this.paramSearch.lsPointSelect = value
            this.fetch(this.paramSearch)
        },
        selectTenant(tenantId, item) {
            this.selected = tenantId
            this.tenant = item
            this.isSelected = true
            this.isCreateTenant = false
        },
        getListSection() {
            let app = this;
            axios.get('/admin/sections/getListSection').then(response => {
                app.listSection = response.data
                app.filterListSection = app.listSection.slice(1);
            });
        },
        getListCategory() {
            let app = this;
            axios.get('/admin/categories/getListCategory').then(response => {
                app.listCategory = response.data
                app.filterListCategory = app.listCategory.slice(1)
            });
        }
    },
    watch: {
        tenantNameSearch: function (val) {
            this.isCreateTenant = false;
            this.isSelected = false;

            if (this.watcher) {
                this.paramSearch.tenantNameSearch = val
                this.fetch(this.paramSearch)
            }
        },
    }
}
</script>
